<!-- 一校 -->
<template>
    <div class="school flex-layout">
        <div class="left">
            <div class="item flex-align-around" :class="{ 'item_active': index == 0 }" v-for="(item, index) in list"
                :key="index" @click="handle(index)">{{ item }}</div>
        </div>
        <div class="right">
            <div class="line"></div>
            <p>京蒙云端校是迎接教育数字化转型的一个探索之举，云端学校采用信息化智能手段，打破了传统学校的物理围墙，尝试建立起适应智能时代要求的教学方式、学习方式和教研模式。</p>
            <p> 京蒙云端校是虚拟的云端校和实体的京蒙协作组团式帮扶、结对式帮扶的学校的有机融合，是有组织京蒙协作的一个阵地，是京蒙 18 名校长、72 名骨干教师、486 对结对校双方开展教学、组织管理的熔炉</p>
            <p> 京蒙云端校是从扶贫到协作的一个转变。充分发挥充分京蒙协作两地人员、尤其是内蒙古自治区方面老师的作用，打破内蒙仅仅是受援方的传统观念，为迅速成长的内蒙老师提供一个在虚拟空间敢于发言的场地</p>
            <p>京蒙云端校拟配置基于北京数字学校和内蒙古智慧教育平台的资源库、人工智能的录播系统、课堂行为分析系统作业与评价系统以及课后服务系统，采用大数据系统记录每位参与者的行为数据，跟踪行为轨迹，推送相应的资源圈、任务圈、协作组，跨校组合、多师协同，助力内蒙教育均衡与教育现代化的成长。
            </p>
            <p>京蒙云端建立校委会、轮值校长团队、学校梯级教师学员等组织机制。作为一个探索中的学校，审慎前行，以教育信息化促进教育现代化。</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: ['云校介绍', '组织架构', '云校动态', '成果案例'],
            index: 0
        }
    },
    methods: {
        handle(index) {
            console.log(index);
            if (index) {
                this.$message({
                    message: '暂未开放',
                    type: 'error'
                });
            }
        }
    },
    mounted() { },
};
</script>
<style lang='less' scoped>
.school {
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    padding-top: 20px;
    background: #FFFFFF;

    .left {
        background: #FFFFFF;
        box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
        width: 321px;
        height: 291px;

        .item {
            width: 321px;
            height: 73px;
            color: #353535;
            font-size: 16px;
            border-bottom: 1px dashed #DDDDDD;

            &:last-child {
                border-bottom: none
            }
        }

        .item_active {
            background: #3B73FE;
            color: #fff;
        }
    }

    .right {
        margin-left: 33px;

        .line {
            width: 130px;
            height: 5px;
            background: #3B73FE;
            margin-bottom: 36px;
        }

        p {
            text-indent: 2em;
            color: #353535;
            font-size: 16px;
            line-height: 30px;
            margin-bottom: 10px;
        }
    }
}

@media screen and(max-width:600px) {
    .school {
        width: 900px;
        height: 200vh;
        margin: 0 auto;
        padding-top: 20px;
        background: #FFFFFF;

        .left {
            background: #FFFFFF;
            box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
            width: 321px;
            height: 291px;

            .item {
                width: 321px;
                height: 73px;
                color: #353535;
                font-size: 16px;
                border-bottom: 1px dashed #DDDDDD;

                &:last-child {
                    border-bottom: none
                }
            }

            .item_active {
                background: #3B73FE;
                color: #fff;
            }
        }

        .right {
            margin-left: 33px;

            .line {
                width: 130px;
                height: 5px;
                background: #3B73FE;
                margin-bottom: 36px;
            }

            p {
                text-indent: 2em;
                color: #353535;
                font-size: 16px;
                line-height: 30px;
                margin-bottom: 10px;
            }
        }
    }
}
</style>